import { getTotalHoursForDateRangeFromScheduleRules } from '~/modules/resourcing/common/util/scheduleUtil';
import { compareDateObjects } from '~/modules/common/dates/compare';

export const getProjectAvailableHours = ({
  start,
  end,
  resourceAllocationScheduleRules,
  otherTaskAllocationsSummaryScheduleRules
}) =>
  getTotalHoursForDateRangeFromScheduleRules({
    start,
    end,
    scheduleRules: resourceAllocationScheduleRules
  }) -
  getTotalHoursForDateRangeFromScheduleRules({
    start,
    end,
    scheduleRules: otherTaskAllocationsSummaryScheduleRules || []
  });

export const getInitialEstimatedHoursForTaskAllocation = ({
  initialEstimatedHours,
  projectAvailableHours
}) => {
  if (initialEstimatedHours) {
    return Math.min(initialEstimatedHours, projectAvailableHours);
  }

  return projectAvailableHours;
};

export const startIsAfterEnd = ({ start, end }) =>
  compareDateObjects(start, end) === 1;
